(function(angular) {
    'use strict';

    // TODO: move to separate module that has models
    angular.module('aprima-legacy-common').factory('DoseRange', [
        'ObjUtil',
        DoseRangeFactory,
    ]);

    function DoseRangeFactory(
        ObjUtil
    ) {

        DoseRange.mapFromDto = mapFromDto;
        return DoseRange;

        function DoseRange(obj) {
            ObjUtil.defineReadonlyProps(this, {
                Id: obj.Id,
                WeightRequired: obj.WeightRequired,
                BodySurfaceAreaRequired: obj.BodySurfaceAreaRequired,
                LowDose: obj.LowDose,
                LowDoseUnits: obj.LowDoseUnits,
                HighDose: obj.HighDose,
                HighDoseUnits: obj.HighDoseUnits,
                MaximumDosePerDay: obj.MaximumDosePerDay,
                MaximumDosePerDayUnits: obj.MaximumDosePerDayUnits,
                MaximumSingleDose: obj.MaximumSingleDose,
                MaximumSingleDoseUnits: obj.MaximumSingleDoseUnits,
                MaximumLifetimeDose: obj.MaximumLifetimeDose,
                MaximumLifetimeDoseUnits: obj.MaximumLifetimeDoseUnits,
                NteAmountPerSingleDose: obj.NteAmountPerSingleDose,
                NteAmountPerSingleDoseUnits: obj.NteAmountPerSingleDoseUnits,
                LowFrequency: obj.LowFrequency,
                HighFrequency: obj.HighFrequency,
                LowDuration: obj.LowDuration,
                HighDuration: obj.HighDuration,
                AdjustedLowDose: obj.AdjustedLowDose,
                AdjustedHighDose: obj.AdjustedHighDose,
                AdjustedMaximumSingleDose: obj.AdjustedMaximumSingleDose,
                AdjustedMaximumDosePerDay: obj.AdjustedMaximumDosePerDay,
                AdjustedMaximumLifetimeDose: obj.AdjustedMaximumLifetimeDose,
                AdjustedNteAmountPerSingleDose: obj.AdjustedNteAmountPerSingleDose,
                RangeLowDose: obj.RangeLowDose,
                RangeLowDoseUnits: obj.RangeLowDoseUnits,
                RangeHighDose: obj.RangeHighDose,
                RangeHighDoseUnits: obj.RangeHighDoseUnits,
                RangeLowDoseForm: obj.RangeLowDoseForm,
                RangeLowDoseFormUnits: obj.RangeLowDoseFormUnits,
                RangeHighDoseForm: obj.RangeHighDoseForm,
                RangeHighDoseFormUnits: obj.RangeHighDoseFormUnits,
                NtePediDailyDoseStrength: obj.NtePediDailyDoseStrength,
                NtePediDailyDoseStrengthUnits: obj.NtePediDailyDoseStrengthUnits,
                NtePediDailyDoseForm: obj.NtePediDailyDoseForm,
                NtePediDailyDoseFormUnits: obj.NtePediDailyDoseFormUnits,
                IngredientStrength: obj.IngredientStrength,
                IngredientStrengthUomAbbr: obj.IngredientStrengthUomAbbr,
                IngredientStrengthUomDesc: obj.IngredientStrengthUomDesc,
                IngredientVolume: obj.IngredientVolume,
                IngredientVolumeUomAbbr: obj.IngredientVolumeUomAbbr,
                IngredientVolumeUomDesc: obj.IngredientVolumeUomDesc,
                WeightKg: obj.WeightKg,
                BodySurfaceArea: obj.BodySurfaceArea,
                ErrorMsg: obj.ErrorMsg,
                HasError: obj.HasError,
            });
        }

        function mapFromDto(obj) {
            if(!obj) {
                return null;
            }

            return new DoseRange(obj);
        }
    }

})(window.angular);
